export default {"src":"/_next/static/media/bankCredit.1e54d00e.svg","height":54,"width":51};